import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import { Checkmark, CheckmarkProps } from '@rhg/libs/material/icons';
import { sxAppend } from '@rhg/libs/material/sx';

const styleBox = {
    height: DS_HEIGHT.BUTTON_SMALL,
    width: DS_HEIGHT.BUTTON_SMALL,
    borderRadius: '50%',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'info.light' : 'info.dark',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

interface CompletedStatusProps {
    sx?: SxProps<Theme>;
    size: CheckmarkProps['size'];
}
export function CompletedStatus({ sx, size }: CompletedStatusProps) {
    return (
        <Box sx={sxAppend(styleBox, sx)}>
            <Checkmark color="info" size={size} />
        </Box>
    );
}
